import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, Image, ScrollView, View } from "react-native"
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from "react-redux"
import OrderCard from '../../Componentsv1/OrderCard';
import PlayerOrderStatCard from '../../Componentsv1/PlayerOrderStatCard';
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { comps_getCompetitionHistoryByRange, comps_getCompetitionPlayerBracketsByPlayerId, comps_getCompetitionSeasonsByAdminId, comps_getEnteredCompetitions, comps_getEnteredSeasons, comps_getInvitedCompetitions } from '../../store/actionsv1/comps';
import { event_getBulkEvents } from '../../store/actionsv1/events';
import { market_getH2HRequestsByH2HId, market_getOrderHistoryByPlayerId, market_getOrdersByPlayerId } from '../../store/actionsv1/markets';
import { HedgeProps, MarketProps, OrderProps, OrderStatsProps } from '../../store/types/mk_svc';
import { BracketCompetitionProps, CompetitionPlayerBracketProps, CompetitionPlayerProps, CompetitionProps, CompetitionSeasonProps } from '../../store/types/tp_svc';
import BracketCompetitionCard from '../Brackets/BracketComponents/BracketCompetitionCard';
import CompetitionCard from '../Comps/components/CompetitionCard';
import { hedge_getHedgesFromPositions } from './helpers/hedges';
import { order_getAllOrderStatsFromOrders, order_getOrderStatsFromOrders } from './helpers/orders';


const DashboardScreen = ({ navigation }:any) => {
    const [ loading, setLoading ] = useState(false)
    const [ loaded, setLoaded ] = useState({
        live_orders: 0,
        competitions: 0,
        order_history:0
    })
    const [ activeSnapshot, setActiveSnapshot ] = useState('positions')
    const [ active_tab, setActiveTab ] = useState('live');
    
    const dispatch = useDispatch()
    const market_type:string = useSelector((state:any) => state.auth.market_type, (left, right) => left == right)
    const app_size:any = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width)
    const markets:MarketProps[] = useSelector((state:any) => state.market.markets, (left, right) => left?.length == right?.length);
    const stored_competitions:{ updated:number, competitions:CompetitionProps[] } = useSelector((state:any) => state.comp.stored_competitions, (left, right) => left.updated == right.updated)
    const invited_competition_players:CompetitionPlayerProps[] = useSelector((state:any) => state.comp.invited_competition_players.filter(cp => cp.status === 'invited'), (left, right) => left?.length == right?.length)
    
    const bracket_competitions_list: {updated: number, bracket_competitions:BracketCompetitionProps[]} = useSelector((state:any) => state.comp.bracket_competitions_list, (left, right) => left.updated == right.updated)
    const { bracket_competitions } = bracket_competitions_list;
   const orders_state:{updated:number, orders:OrderProps[]} = useSelector((state:any) => state.player.orders, (left, right) => left.updated == right.updated)
    const orders = orders_state.orders.filter(o => o.market_type === market_type)
    let hedges:HedgeProps[] = hedge_getHedgesFromPositions(orders, markets)

    const player = useSelector((state:any) => state.player.player, (left:any, right:any) => left?.player_id == right?.player_id)

    const competition_player_brackets_list: { updated:number, competition_player_brackets:CompetitionPlayerBracketProps[] } = useSelector((state:any) => state.comp.competition_player_brackets_list, (left, right) => left.updated == right.updated)
    let competition_player_brackets = competition_player_brackets_list.competition_player_brackets.filter(cpb => cpb.player_id == player?.player_id && cpb.status !== 'deleted')

    const competition_seasons_list:{ updated:number, competition_seasons:CompetitionSeasonProps[] } = useSelector((state:any) => state.comp.competition_seasons_list, (left, right) => left.updated == right.updated);
    const admin_seasons = competition_seasons_list.competition_seasons.filter(cs => (cs.admin_id == player?.player_id || cs.entered) && cs.market_type == market_type);


    const h2h_requests = useSelector((state:any) => state.player.h2h_requests.filter((o:OrderProps) => o.status === 'approved'), (left:any, right:any) => {
        if(left.length !== right.length){ return false }
        return true
    })

    useEffect(() => {
        if(!player){ return }
        if(active_tab === 'live'){ 
            getDataFromServer(player.player_id, 0) 
        }
        if(active_tab === '7days'){ 
            getOrderHistoryFromServer(player.player_id, 0)
         }
    },[active_tab])

    useEffect(() => {
        if(activeSnapshot === 'positions'){ return }
        getDataFromServer(player?.player_id, 0)
    },[activeSnapshot])

    useEffect(() => {
        if(orders.length === 0){ return }
        let event_ids = [ ...new Set(orders.filter(o => o.event_type === 'team').map(o => o.event_id)) ]
        getEventDataFromServer(event_ids)
    },[orders.length])

    const filterCompetitions = () => {
        switch(active_tab){
            case 'live':
                const entered_competitions = stored_competitions.competitions.filter(c => c.entered && c.status !== 'closed')
                const invited_competitions = stored_competitions.competitions.filter(c => c.status !== 'closed' && invited_competition_players.map(cp => cp.competition_id.toString()).includes(c.competition_id.toString()))
                return invited_competitions.concat(entered_competitions)
            case '7days':
                return stored_competitions.competitions.filter(c => c.status === 'closed' && moment(c.last_update_datetime).isAfter(moment().subtract(7,'days')))
            case '30days':
                return stored_competitions.competitions.filter(c => c.status === 'closed' && moment(c.last_update_datetime).isAfter(moment().subtract(30,'days')))
            default: return stored_competitions.competitions
        }
    }

    const filterCompetitionPlayerBrackets = () => {
        switch(active_tab){
            case 'live':
                return [ ...new Set(competition_player_brackets.filter(cpb => cpb.status == 'active').map(cpb => cpb.bracket_competition_id))];
            default:
                return [ ...new Set(competition_player_brackets.filter(cpb => cpb.status == 'closed').map(cpb => cpb.bracket_competition_id))];
        }
    }

    const filterOrders = () => {
        switch(active_tab){
            case 'live': return orders.filter(o => o.resolution_status === 'inprogress')
            case '7days': return orders.filter(o => o.resolution_status === 'closed' && o.called_amt > 0 && moment(o.last_update_datetime).isAfter(moment().subtract(7, 'days')))
            case '30days': return orders.filter(o => o.resolution_status === 'closed' && o.called_amt > 0 && moment(o.last_update_datetime).isAfter(moment().subtract(30, 'days')))
            default: return orders
        }
    }
    

    const getDataFromServer = async(player_id:string, offset:number) => {
        let now = moment().unix()
        //if(activeSnapshot === 'positions' && loaded.live_orders !== 0 && now - loaded.live_orders < 10){ return } //already loaded these
        setLoading(true)
        if(activeSnapshot === 'positions'){
            await dispatch(market_getOrdersByPlayerId(player_id, 0, true, 'inprogress'))
            await dispatch(market_getH2HRequestsByH2HId(player_id))
        } else {
            await dispatch(comps_getCompetitionPlayerBracketsByPlayerId(player_id, undefined, 'active'))
            await dispatch(comps_getCompetitionSeasonsByAdminId('active'))
            await dispatch(comps_getEnteredSeasons())
            await dispatch(comps_getEnteredCompetitions())
            await dispatch(comps_getInvitedCompetitions())
        }
        setLoaded({ ...loaded, competitions: now, live_orders:now })
        setLoading(false)
    }

    const getOrderHistoryFromServer = async(player_id:string, offset:number) => {
        let now = moment().unix()
        //if(loaded.order_history !== 0 && now - loaded.order_history < 60){ return } //already loaded these
        setLoading(true)
        if(activeSnapshot === 'positions'){
            await dispatch(market_getOrderHistoryByPlayerId(player_id, 7))
        } else {
            await dispatch(comps_getCompetitionPlayerBracketsByPlayerId(player_id, undefined, 'closed', 7))
            await dispatch(comps_getCompetitionHistoryByRange(player_id, 7))
        }
        setLoading(false)
        setLoaded({ ...loaded, order_history: now })
    }

    const getEventDataFromServer = async(event_ids:string[]) => {
        await dispatch(event_getBulkEvents(event_ids))
    }
    const renderH2HRequests = (data: { item:OrderProps, index:number }) => {
        return (
            <View style={{ margin:5, marginRight:15, marginLeft:15 }}>
                <OrderCard prevent_event_load view_mode='edit' order={data.item} h2h_request={true}/>
            </View>
        )
    }

    const renderSeasons = (data: { item:CompetitionSeasonProps, index:number }) => {
        return (
            <TouchableOpacity 
                style={{ flexDirection:'row', alignItems:'center', margin:5, padding:10, borderRadius:8, borderWidth:1, borderColor:Colors.shades.shade600 }}
                onPress={() => navigation.navigate('CompetitionStack', { screen:'CompetitionSeason', initial:false, params: { competition_season_id: data.item.competition_season_id } })}
                >
                <Image
                    style={{ height:30, width:60, padding:5 }}
                    source={{ uri: data.item.image?.url }}
                    resizeMode='cover'
                />
                <View style={{ flex:1, marginLeft:10 }}>
                    <Text size={14} color={Colors.brand.midnight} weight='semibold'>{data.item.season_name}</Text>
                    <Text size={14} color={Colors.brand.midnight} weight='regular'>{data.item.season_description}</Text>
                </View>
                <Icon name='chevron-right' type='feather' size={16} color={Colors.brand.midnight} />
            </TouchableOpacity>
        )
    }

    const renderOrderEventStats = (data: {item: OrderStatsProps, index:number}) => {
        const event_hedges = hedges.filter(h => h.event_id == data.item.event_id && h.event_type == data.item.event_type)
        return (
            <View style={{margin:5}}>
                <PlayerOrderStatCard hedges={event_hedges} prevent_event_load player_order_stat={data.item} 
                onPress={(ps) => { 
                    return navigation.navigate('EventStack', { 
                        screen:'EventOrders', 
                        initial:false, 
                        onGoBack: () => console.log('hey!'), 
                        params: { event_id: ps.event_id, event_type: ps.event_type }
                })}}
                />
            </View>
        )
    }

    const renderCompetitions = (data: {item:CompetitionProps, index:number}) => {
        return (
            <View style={{ margin:10 }}>
                <CompetitionCard competition={data.item} onSelect={(competition) => navigation.navigate('CompetitionStack', { screen: 'CompetitionPlay', initial:false, params: {competition_id:competition.competition_id} })}/>
            </View>
        )
    }

    const renderBracketCompetitions = (data: {item:string, index:number}) => {
        const bracket_competition = bracket_competitions.find(bc => bc.bracket_competition_id == data.item)
        if(!bracket_competition){ return <></> }
        const entered_brackets = competition_player_brackets.filter(cpb => cpb.bracket_competition_id == data.item)
        return (
            <BracketCompetitionCard entered_brackets={entered_brackets} bracket_competition={bracket_competition} onSelect={() => navigation.navigate('CompetitionStack', { screen: 'BracketPlay', initial:false, params: {bracket_competition_id:bracket_competition.bracket_competition_id} })}/>
        )
    }


   
    const cl = market_type === 'FOR_MONEY' ? '$' : 'E'

    if(!player){ return <></> }
    const filtered_orders = filterOrders()
    const filtered_competitions = filterCompetitions()
    const order_event_stats = order_getOrderStatsFromOrders(filtered_orders).sort((a,b) => b.open_amt - a.open_amt)
    const order_stats = order_getAllOrderStatsFromOrders(filtered_orders)
    const filtered_bracket_competition_ids = filterCompetitionPlayerBrackets()
    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView style={{ flex:1 }}>
            <View style={{backgroundColor:Colors.brand.electric}}>
                    <View style={{justifyContent:'center', alignItems:'center', padding:20}}>
                        <Text size={20} color={Colors.shades.white} weight='bold' textAlign='center'>Welcome Back {player.first_name} ...</Text>
                    </View>
                    <View style={{flexDirection:'row', alignItems:'center', backgroundColor:Colors.brand.midnight, padding:4, borderRadius:22, marginLeft:30, marginRight:30, marginBottom:20 }}>
                        <TouchableOpacity style={{flex:1, padding:10, backgroundColor:active_tab==='live'?Colors.brand.midnightTopGradient:'transparent', borderRadius:22}} onPress={() => setActiveTab('live')}>
                            <Text size={14} color={Colors.shades.white} weight='bold' textAlign='center'>ACTIVE</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{flex:1, padding:10, backgroundColor:active_tab==='7days'?Colors.brand.midnightTopGradient:'transparent', borderRadius:22}} onPress={() => setActiveTab('7days')}>
                            <Text size={14} color={Colors.shades.white} weight='bold' textAlign='center'>SETTLED LAST 7 DAYS</Text>
                        </TouchableOpacity>
                    </View>
                    
                {activeSnapshot === 'competitions' ?
                <View style={{backgroundColor:'#00427f', borderTopRightRadius:27, borderTopLeftRadius:27}}>
                    <TouchableOpacity style={{ borderTopRightRadius:27, borderTopLeftRadius:27, padding:15, paddingBottom:30, backgroundColor:'#00427f' }} onPress={() => setActiveSnapshot('positions')}>
                        <Text size={16} color={Colors.shades.white} weight='bold' textAlign='center'>My Orders</Text>
                    </TouchableOpacity>
                </View>
                :<></>}
                {activeSnapshot === 'positions' ? 
                <View style={{flex:1}}>
                    <View style={{flex:1, backgroundColor:Colors.shades.white, borderTopRightRadius:27, borderTopLeftRadius:27}}>
                        <View style={{ backgroundColor:Colors.shades.shade100, margin:20, padding:10, borderRadius:12 }}>
                            <View style={{flex:1, flexDirection:'row' }}>
                                <View style={{ flex:1/8 }} />
                                <Text style={{ flex:6/8 }} textAlign='center' size={18} color={Colors.brand.midnight} weight='bold'>My Orders / Positions</Text>
                                <TouchableOpacity style={{ flex:1/8, justifyContent:'center', alignItems:'flex-end' }} onPress={() => navigation.navigate('SocialStack', { screen: 'Shareable' })}>
                                    <Icon name='share' type='feather' color={Colors.brand.midnight} size={16} />
                                </TouchableOpacity>
                            </View>
                            <View style={{ flexDirection:'row', alignItems:'center', marginTop:20, padding:10, borderRadius:8, backgroundColor:Colors.incentive.gold_faded}}>
                                <View style={{ flex:1, marginRight:10 }}>
                                    <Text size={14} color={Colors.brand.midnight} weight='bold'>BettorEdge API</Text>
                                    <Text style={{ marginTop:3 }} size={12} color={Colors.brand.midnight} weight='regular'>{player.type == 'premium'?'View API documentation':'Would you like to access this and other data using the BettorEdge API?'}</Text> 
                                </View>
                                {player.type == 'premium' ?
                                <TouchableOpacity style={{ padding:10, backgroundColor:Colors.incentive.gold, borderRadius:8 }} onPress={() => window.open('https://engage.bettoredge.com', '_blank')}>
                                    <Text size={14} color={Colors.shades.white} textAlign='center' weight='bold'>View API</Text>
                                </TouchableOpacity>
                                :
                                <TouchableOpacity style={{ padding:10, backgroundColor:Colors.incentive.gold, borderRadius:8 }} onPress={() => navigation.navigate('AuthStack', { screen:'Premium' })}>
                                    <Text size={14} color={Colors.shades.white} textAlign='center' weight='bold'>View Premium</Text>
                                </TouchableOpacity>
                                }
                            </View>
                        </View>
                        <View nativeID="order_stats" style={{ flexDirection:'row', justifyContent:'center', flexWrap:'wrap' }}>
                        {order_stats.open_amt > 0 ?
                        <View style={{ justifyContent:'space-between', width: (app_size.width/2) - 20, borderRadius:12, backgroundColor:Colors.shades.shade200, padding:20, margin:8}}>
                            <Text size={14} color={Colors.brand.cobalt}>Unfulfilled Order Amount</Text>
                            <Text size={16} weight='semibold' color={Colors.brand.cyan} style={{ marginTop:3 }}>{cl}{order_stats.open_amt.toFixed(2)}</Text>
                        </View>
                        :<></>}
                        {order_stats.unresolved_stake > 0 ?
                        <View style={{ justifyContent:'space-between', width: (app_size.width/2) - 20, borderRadius:12, backgroundColor:Colors.shades.shade200, padding:20, margin:8}}>
                            <Text size={14} color={Colors.brand.cobalt}>Unsettled Positions</Text>
                            <Text size={16} weight='semibold' color={Colors.brand.midnight} style={{ marginTop:3 }}>{order_stats.unresolved_stake.toFixed(2)} to win {cl}{order_stats.unresolved_potential_winnings.toFixed(2)}</Text>
                        </View>
                        :<></>}
                        {order_stats.resolved_stake > 0 ?
                        <View style={{ justifyContent:'space-between', width: (app_size.width/2) - 20, borderRadius:12, backgroundColor:Colors.shades.shade200, padding:20, margin:8}}>
                            <Text size={14} color={Colors.brand.cobalt}>Settled Positions</Text>
                            <Text size={16} weight='semibold' color={Colors.brand.midnight} style={{ marginTop:3 }}>{cl}{order_stats.resolved_stake.toFixed(2)}</Text>
                        </View>
                        :<></>}
                        {order_stats.resolved_stake > 0 ?
                        <View style={{ justifyContent:'space-between', width: (app_size.width/2) - 20, borderRadius:12, backgroundColor:Colors.shades.shade200, padding:20, margin:8}}>
                            <Text size={14} color={Colors.brand.cobalt}>Earnings</Text>
                            <Text size={16} weight='semibold' color={Colors.brand.midnight} style={{ marginTop:3 }}>{cl}{order_stats.earnings.toFixed(2)} ({(order_stats.roi * 100).toFixed(2)}%)</Text>
                        </View>
                        :<></>}
                        {order_stats.delayed_cash > 0 ?
                        <View style={{ justifyContent:'space-between', width: (app_size.width/2) - 20, borderRadius:12, backgroundColor:Colors.shades.shade200, padding:20, margin:8}}>
                            <Text size={14} color={Colors.brand.cobalt}>Delayed Cash Out</Text>
                            <Text size={16} weight='semibold' color={Colors.brand.midnight} style={{ marginTop:3 }}>{cl}{order_stats.delayed_cash.toFixed(2)}</Text>
                        </View>
                        :<></>}
                    </View>
                    
                    {loading ?
                    <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                        <ActivityIndicator size='large' color={Colors.brand.midnight} />
                    </View>
                    : 
                    <View>
                        <FlatList data={h2h_requests} renderItem={renderH2HRequests} keyExtractor={(item) => item.order_id.toString()} />
                        <FlatList data={order_event_stats.sort((a,b) => moment(a.last_update_datetime).unix() - moment(b.last_update_datetime).unix() )} renderItem={renderOrderEventStats} keyExtractor={(item) => item.stat_id} />
                        {h2h_requests.length === 0 && order_event_stats.length === 0 ?
                        <View style={{ justifyContent:'center', alignItems:'center', padding:10, marginTop:20 }}>
                            <View style={{ borderRadius:8, backgroundColor:Colors.highlights.highlight500Faded, padding:10, shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 }}>
                                <Text style={{ margin:5 }} size={18} color={Colors.brand.midnight} weight='bold' textAlign='center'>Create an Order!</Text>
                                <Text style={{ margin:5 }} size={14} color={Colors.brand.midnight} weight='regular' textAlign='center'>Open orders and unsettled positions can be viewed and managed here.  Settled positions can be viewed using the last 7 days tab or through the performance history.</Text>
                                <View style={{ justifyContent:'center', alignItems:'center' }}>
                                    <Image style={{ margin:5, height:app_size.width * 0.4, width:app_size.width * 0.584 }} resizeMode='contain' source={'https://res.cloudinary.com/hoabts6mc/image/upload/v1677520352/orders_empty_state_fk6dac.webp'} />
                                </View>
                                <TouchableOpacity style={{ margin:10, padding:10, backgroundColor:Colors.utility.success, borderRadius:4 }} onPress={() => navigation.navigate('EventStack', { screen: 'Events' })}>
                                    <Text size={14} color={Colors.shades.white} textAlign='center'>Create Order</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                        :<></>}
                    </View>
                    }
                    </View>
                </View>
                :
                <View style={{flex:1, backgroundColor:Colors.shades.white}}>
                    <View style={{flex:1, marginTop:-15, backgroundColor:Colors.shades.white, borderTopRightRadius:27, borderTopLeftRadius:27}}>
                        <View style={{ backgroundColor:Colors.shades.shade100, margin:20, padding:20, borderRadius:12 }}>
                            <Text textAlign='center' size={18} color={Colors.brand.midnight} weight='bold'>My Competitions</Text>
                        </View>
                    </View>
                    <View style={{ marginTop:10 }}>
                        <FlatList data={admin_seasons} renderItem={renderSeasons} />
                        <FlatList data={filtered_bracket_competition_ids} renderItem={renderBracketCompetitions} />
                        <FlatList data={filtered_competitions} renderItem={renderCompetitions} keyExtractor={(item) => item.competition_id.toString()} />
                    </View>
                </View>
                }
            </View>
            </ScrollView>
            {activeSnapshot === 'positions' ?
            <View style={{backgroundColor:'#00427f', borderTopRightRadius:27, borderTopLeftRadius:27}}>
                <TouchableOpacity style={{ borderTopRightRadius:27, borderTopLeftRadius:27, padding:15, shadowColor: "rgba(0, 0, 0, 0.2)", shadowOffset: { width: 0, height: 4 }, shadowRadius: 20, shadowOpacity: 1, backgroundColor:'#00427f' }} onPress={() => setActiveSnapshot('competitions')}>
                    <Text size={16} color={Colors.shades.white} weight='bold' textAlign='center'>My Competitions</Text>
                </TouchableOpacity>
            </View>
            :<></>}
        </View>
    )
}

const localStyles = {
    activeTabStyle: { flex:1, padding:10, backgroundColor:Colors.brand.midnightTopGradient, borderRadius:22 },
    inactiveTabStyle: { flex:1/3, padding:10, borderRadius:22 },
    snashotClosedStyle: { backgroundColor: Colors.shades.white, borderTopRightRadius: 42, borderTopLeftRadius: 42, paddingBottom:35, paddingTop:30 },
    inactiveModalStyle: { borderTopRightRadius:27, borderTopLeftRadius:27, padding:15, backgroundColor: "#003566", shadowColor: "rgba(0, 0, 0, 0.2)", shadowOffset: { width: 0, height: 4 }, shadowRadius: 20, shadowOpacity: 1 }
}


export default DashboardScreen